import { LazyLoadImage } from 'react-lazy-load-image-component';

import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { SwitchableSubscription } from '@r1-frontend/ui-react/organisms/TariffSubscription';
import { TSwitchableSubscriptionProps } from '@r1-frontend/ui-react/organisms/TariffSubscription/SwitchableSubscription/SwitchableSubscription';

const Desktop = ({
    imagePath,
    children,
    cost,
    oldCost,
    description,

    onIconClick,
    onToggle,

    checked,
    required,
    disabled,

    ...props
}: Omit<TSwitchableSubscriptionProps, 'switcherAlign' | 'type' | 'Icon'> & { imagePath: string }): JSX.Element => {

    return (
        <div {...props}>
            <LazyLoadImage src={imagePath} alt={children} title={children} visibleByDefault />
            <IndentContainer $united={[24, 24, 48]}>
                <SwitchableSubscription
                    description={description}
                    switcherAlign={'start'}
                    onIconClick={onIconClick}
                    cost={cost}
                    oldCost={oldCost}
                    onToggle={onToggle}
                    checked={checked}
                    required={required}
                    disabled={disabled}
                    Icon={InfoCircleFlip}
                >
                    {children}
                </SwitchableSubscription>
            </IndentContainer>
        </div>
    );
};

export default Desktop;
